module.exports = __webpack_public_path__ + "static/media/visa_icon.19c92bec.svg";